// @flow

import { type UserInputValidationError, VALID } from '@tectonics/prs/validation';

export function validateColombianAddress(addressValue: string): ?UserInputValidationError {
  return addressValue ? VALID : { id: 'empty' };
}
